module.exports = __webpack_public_path__ + "static/img/7.8db050d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/7.png
// module id = 3iIl
// module chunks = 0